/*
 * Created on Wed Aug 09 2023
 *
 * Project: BKN_FRONT
 * Copyright (c) 2023 Nttdata
 */
import React, { useState } from "react";

import { URL_BKI, APP_TEXT } from "../../constants/URL";

/* COMPONENTES MUI */
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Divider from "@mui/material/Divider";

/*  COLORES */
import { colorVerdFosc } from "../../constants/Colors";

/* ICONOS */
import NoteAddIcon from "@mui/icons-material/NoteAdd";
import TaskIcon from "@mui/icons-material/Task";
import UploadFileIcon from "@mui/icons-material/UploadFile";

/*MENSAJES DE ALERTA*/
import ErrorAlert from "../../components/PantallesBKI/Alertas/ErrorAlert";
import InsertAlert from "../../components/PantallesBKI/Alertas/InsertAlert";
import Alert from '@mui/material/Alert';

function DetallTramits() {

  const [usuari] = useState("am14_19-n2");

  const getGenerarExel = (nomUsuari) => {
    fetch(URL_BKI.GENERAR_FITXER + nomUsuari, {
      headers: {
        "Content-Type": APP_TEXT,
        Accept: APP_TEXT,
      },
    })
      .then((response) => response.text())
      .then((data) => {
        InsertAlert(data);
      })
      .catch((error) => {
        ErrorAlert(
          `Error al generar el fitxer estupefaents. Error: ${error.message}`
        );
      });
  };

  const getCarregarCorregit = (nomUsuari) => {
    fetch(URL_BKI.CARREGAR_FITXER + nomUsuari, {
      headers: {
        "Content-Type": APP_TEXT,
        Accept: APP_TEXT,
      },
    })
      .then((response) => response.text())
      .then((data) => {
        InsertAlert(data);
      })
      .catch((error) => {
        ErrorAlert(
          `Error al carregar el fitxer validat. Error: ${error.message}`
        );
      });
  };

  const getEnviaXML = (nomUsuari) => {
    fetch(URL_BKI.ENVIAR_XML + nomUsuari, {
      headers: {
        "Content-Type": APP_TEXT,
        Accept: APP_TEXT,
      },
    })
      .then((response) => response.text())
      .then((data) => {
        InsertAlert(data);
      })
      .catch((error) => {
        ErrorAlert(`Error al enviar l'XML. Error: ${error.message}`);
      });
  };

 


  return (
    <div className="w-100, boxPantalla">
      <h2>Detall Tramits </h2>

      <Alert severity="info" className="infoUser">Per realitzar les accions relacionades amb el tràmit SAL016, cal estar connectat amb l'usuari AM14_19-N2</Alert>
      
   
      <Stack
        direction="row"
        spacing={8}
        justifyContent="center"
        divider={<Divider orientation="vertical" flexItem />}
      >
        <Button
          variant="contained"
          color="primary"
          startIcon={<NoteAddIcon />}
          sx={colorVerdFosc}
          size="small"
          onClick={() => getGenerarExel(usuari)}
        >
          Generar fitxer estupefaents
        </Button>

        <Button
          variant="contained"
          sx={colorVerdFosc}
          color="primary"
          startIcon={<UploadFileIcon />}
          size="small"
          onClick={() => getEnviaXML(usuari)}
        >
          Enviar XMLs
        </Button>

        <Button
          variant="contained"
          color="primary"
          startIcon={<TaskIcon />}
          sx={colorVerdFosc}
          size="small"
          onClick={() => getCarregarCorregit(usuari)}
        >
          Carregar fitxer validat
        </Button>
      </Stack>
    </div>
  );
}
export default DetallTramits;
